import httpManager from "@/app/shared/utils/httpManager";

/**
 * Regenerar una estrategia a partir de una existente.
 *
 * @param {number} strategyId Identificador de la estrategis.
 * @param {string} name Nombre de la estrategia nueva.
 * @param {Object} filters Filtros para aplicar en la nueva estrategia.
 *
 * @return {Promise<Object>} Nueva estrategia regenerada.
 */
export async function createStrategyByRegeneration(strategyId, name, filters, contact_direct) {
  const response = await httpManager.post(`/strategies/${strategyId}/regeneration/`, {
    name_regenerate: name,
    filters: filters,
    contact_direct_exclude: contact_direct,
  });

  return response.data;
}
